import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { User } from '../models/user';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiService = inject(ApiService);

  private currentUserSubject = new BehaviorSubject<User | null>(null);
  currentUser = this.currentUserSubject.asObservable();


  getUser(userId: number|'current', params: any = {}): Observable<any> {
    return this.apiService.get(`secure/users/${userId}`, params);
  }

  updateUser(userId: number|'current', params: any): Observable<any> {
    return this.apiService.put(`secure/users/${userId}`, params);
  }

  updateCurrentUser(params: any): Observable<any> {
    return this.updateUser('current', params);
  }

  sendPasswordChangeRequest(params: any): Observable<any> {
    return this.apiService.post(`secure/change-password-request`, params);
  }

  changePassword(params: any): Observable<any> {
    return this.apiService.post(`secure/change-password`, params);
  }

  getCurrentUser(): Observable<User> {
    return this.getUser('current', { include: 'permissions,roles,institutions' })
      .pipe(
        map(
          (response) => {
            this.currentUserSubject.next(response.data);
            return response.data;
          }
        )
      );
  }

  getCurrentUserInstitutions(params: any = {}): Observable<any> {
    return this.apiService.get(`secure/users/current/institutions`, params);
  }

  getUserData(storageName: string, key: string): any {
    const userKey = 'user_' + this.currentUserSubject.value?.id;
    if (localStorage.getItem(storageName)) {
      const data = JSON.parse(localStorage.getItem(storageName)||'{}');
      if (data[userKey]) {
        if (key) {
          return data[userKey][key];
        } else {
          return data[userKey];
        }
      }
    } else { return null; }
  }

  setUserData(storageName: string, key: string,  params: any): any {
    const userKey = 'user_' + this.currentUserSubject.value?.id;
    const data = localStorage.getItem(storageName) ? JSON.parse(localStorage.getItem(storageName)||'{}') : {};
    if (!data[userKey]) {
      data[userKey] = {};
      data[userKey][key] = params;
    } else {
      data[userKey][key] = params;
    }
    return localStorage.setItem(storageName, JSON.stringify(data));
  }

  deleteUserData(storageName: string, key: string): any {
    const userKey = 'user_' + this.currentUserSubject.value?.id;
    if (localStorage.getItem(storageName)) {
      const data = JSON.parse(localStorage.getItem(storageName)||'{}');
      if (data[userKey][key]) {
        delete data[userKey][key];
        return localStorage.setItem(storageName, JSON.stringify(data));
      }
    } else { return null; }
  }

}
